import { formatNumber } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  ValidationErrors,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-edit-payment-amount-input',
  templateUrl: './edit-payment-amount-input.component.html',
  styleUrls: ['./edit-payment-amount-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditPaymentAmountInputComponent implements OnInit, OnChanges {
  @Input() paymentAmount: number;
  @Input() maxVal: number;
  @Input() disabled: boolean;
  @Input() isTouch: boolean;
  @Output() updatePaymentAmountEmitter: EventEmitter<{
    paymentAmount: number;
    errors: ValidationErrors;
  }> = new EventEmitter();
  paymentAmountControl: FormControl;

  ngOnInit() {
    this.paymentAmountControl = new FormControl(this.paymentAmount, {
      validators: [Validators.min(0.01), this.maxValidator.bind(this)],
      updateOn: 'blur',
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.paymentAmountControl &&
      changes?.paymentAmount.currentValue !== this.paymentAmountControl?.value
    ) {
      this.paymentAmountControl.setValue(changes.paymentAmount.currentValue);
      this.paymentAmountControl.updateValueAndValidity();
    }
  }

  updatePaymentAmount(event: any) {
    const newValue = parseFloat(
      (event.currentTarget.value || '0').replace(/,/g, ''),
    );
    if (newValue != this.paymentAmountControl.value) {
      this.paymentAmountControl.setValue(newValue);
      this.paymentAmountControl.updateValueAndValidity();
      this.updatePaymentAmountEmitter.emit({
        paymentAmount: newValue,
        errors: this.paymentAmountControl?.errors,
      });
    }
    event.currentTarget.value = formatNumber(newValue, 'en-US', '1.2-2');
  }

  maxValidator(control: AbstractControl) {
    return control.value > this.maxVal ? { max: true } : null;
  }
}
